import {isFeatureEnabled} from '@github-ui/feature-flags'
import {BetaLabel} from '@github-ui/lifecycle-labels/beta'

import {LABELS} from '../constants/labels'
import styles from './CallToActionItem.module.css'

type CallToActionProps = {
  showBetaPill?: boolean
}

export function CallToActionItem({showBetaPill}: CallToActionProps) {
  const enabled = isFeatureEnabled('lifecycle_label_name_updates')

  if (!showBetaPill) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <BetaLabel>{enabled ? LABELS.preview : LABELS.beta}</BetaLabel>
    </div>
  )
}
